<div class="ball" #graphContainer>
  <!-- <ion-fab vertical="bottom" horizontal="start" slot="fixed">
    <img [src]="auth.business?.logo" width="70px" height="75px" style="margin-bottom: 10px;" class="circular">
  </ion-fab> -->
  <ngx-graph id="ngxGraph" [zoomLevel]="zoomFactor" [links]="swim.links" [nodes]="swim.nodes" [clusters]="clusters"
    [layout]="'dagreCluster'" [layoutSettings]="dagreSettings" [curve]="curve" [draggingEnabled]="false"
    [panningEnabled]="true" [enableZoom]="false" [update$]="update$" [center$]="center$" [zoomToFit$]="zoomToFit$">
    <ng-template #defsTemplate>
      <svg:marker id="arrow" viewBox="0 -5 10 10" refX="20" refY="0" markerWidth="4" markerHeight="4" orient="auto">
        <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
      </svg:marker>
    </ng-template>

    <ng-template #clusterTemplate let-cluster>
      <svg:g class="node cluster">
        <svg:rect rx="5" ry="5" [attr.width]="cluster.dimension.width" [attr.height]="cluster.dimension.height"
          [attr.fill]="cluster.data.color" />
      </svg:g>
    </ng-template>

    <ng-template #nodeTemplate let-node>
      <svg:g class="node" id="main">
        <!-- Rectangle for the node -->
        <svg:rect [attr.width]="node.dimension.width + 70" [attr.height]="node.dimension.height" rx="10" ry="10"
          [attr.fill]="'#ED991B'" *ngIf="selectedNode && selectedNode.id==node.id" />
        <svg:rect [attr.width]="node.dimension.width + 70" [attr.height]="node.dimension.height" rx="10" ry="10"
          [attr.fill]="'#8BBB2B'" *ngIf="!selectedNode || selectedNode.id!=node.id" />

        <!-- Image for the node -->
        <svg:image [attr.xlink:href]="node.data.url" height="40" width="40" [attr.x]="0" [attr.y]="0"
          (click)="clickImage.emit(node)" />

        <!-- Text for the node label -->
        <svg:text alignment-baseline="central" [attr.x]="45" [attr.y]="10" (click)="clickNode.emit(node)"
          *ngIf="node.label.includes('Late')">
          {{node.label}} 🙏
        </svg:text>
        <svg:text alignment-baseline="central" [attr.x]="45" [attr.y]="10" (click)="clickNode.emit(node)"
          *ngIf="!node.label.includes('Late')">
          {{node.label}} ({{node.age}})
        </svg:text>

        <!-- Text for the spouse label -->
        <svg:text *ngIf="node.data && node.data.spouse" alignment-baseline="central" [attr.x]="45" [attr.y]="30"
          (click)="clickSpouse.emit(node)">
          {{node.data.spouse}}
        </svg:text>

        <!-- Image for the spouse -->
        <svg:image [attr.xlink:href]="node.data.spouse_url" height="40" width="40" [attr.x]="node.dimension.width + 30"
          [attr.y]="0" (click)="clickSpouseImage.emit(node)" />
      </svg:g>
    </ng-template>

    <ng-template #linkTemplate let-link>
      <svg:g class="edge" (click)="clickRelation.emit(link)">
        <svg:path class="line" stroke-width="2" marker-end="url(#arrow)" transform="translate(10, 0)">
        </svg:path>
        <svg:text class="edge-label" text-anchor="middle">
          <textPath class="text-path" [attr.href]="'#' + link.id" [style.dominant-baseline]="link.dominantBaseline"
            startOffset="80%">
            {{link.label}}
          </textPath>
        </svg:text>
      </svg:g>
    </ng-template>
  </ngx-graph>
</div>